import React, { useEffect, useState } from "react";
import MaterialPagination from "../../../styles/materialPagination";
import { useHistory } from "react-router-dom";
import Notification from "../../../elements/notification/Notification";
import WalletsList from "./WalletsList";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { parseAxiosError } from "../../../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import WalletsFilter from "./WalletsFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import { StyledWalletListWrapper } from "../../styledWallets";

const WalletsContainer = ({ t }) => {
  const history = useHistory();

  const [wallets, setWallets] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "walletList", false, true),
    "currency": checkFilterItem(history, "currency", null),
    "paymentSystem": checkFilterItem(history, "paymentSystem", null),
    "wallet": checkFilterItem(history, "wallet", null),
    "tag": checkFilterItem(history, "tag", null),
    "connection.project.name": checkFilterItem(history, "connection.project.name", null),
    "connection.service.name": checkFilterItem(history, "connection.service.name", null),
  });

  const fetchWallets = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/wallets" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setWallets(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  useEffect(() => {
    fetchWallets();
  }, [filterData]);

  return (
    <StyledWalletListWrapper>
      <Helmet>
        <title>{t("wallets.meta.title")}</title>
      </Helmet>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="content-head">
        <WalletsFilter
          t={t}
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ItemsPerPageSelect
          itemsPerPage={filterData.itemsPerPage}
          setItemsPerPage={(data) => setFilterData({
            ...filterData,
            "itemsPerPage": data,
            page: 1
          })}
        />
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <WalletsList
        t={t}
        notification={notification}
        setNotification={setNotification}
        wallets={wallets}
      />
      {totalPageCount > 1 &&
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(event, page) => onChangePage(event, page)}
        />}
    </StyledWalletListWrapper>
  );
};

export default WalletsContainer;